import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Reports from "@/reports/pages/Index";
import Login from "@/auth/pages/Login";
import Logout from "@/auth/pages/Logout";
import ResetPassword from "@/auth/pages/ResetPassword";
import CreateReport from "@/reports/pages/Create";
import EditReport from "@/reports/pages/Edit";
import ViewReport from "@/reports/pages/View";
import Lookup from "@/lookups/pages/Index";
import UserControl from "@/user-control/pages/Index";
import Sites from "@/sites/pages/Index";
import Profile from "@/profile/pages/Index";
import PageNotFound from "@/components/PageNotFound";
import TimeTracking from "@/time-tracking/pages/Index";
import TimeSheet from "@/time-tracking/pages/Timesheet";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        index: true,
        element: <Navigate to="/safety-valve-reports" replace />,
      },
      {
        path: "/safety-valve-reports",
        children: [
          {
            index: true,
            element: <Reports />,
          },
          {
            path: "new",
            element: <CreateReport />,
          },
          {
            path: "edit/:location/:id",
            element: <EditReport />,
          },
          {
            path: "view/:location/:id",
            element: <ViewReport />,
          },
        ],
      },
      {
        path: "/manual-valve-reports",
        children: [
          {
            index: true,
            element: (
              <Reports key="manual-valve-reports" reportType="MANUAL_VALVE" />
            ),
          },
          {
            path: "new",
            element: <CreateReport reportType="MANUAL_VALVE" />,
          },
          {
            path: "edit/:location/:id",
            element: <EditReport reportType="MANUAL_VALVE" />,
          },
          {
            path: "view/:location/:id",
            element: <ViewReport reportType="MANUAL_VALVE" />,
          },
        ],
      },
      {
        path: "/lookups",
        element: <Lookup />,
      },
      {
        path: "/user-management",
        element: <UserControl />,
      },
      {
        path: "/sites",
        element: <Sites />,
      },
      {
        path: "time-tracking",
        element: <TimeTracking />,
      },
      {
        path: "time-tracking/timesheet/:userId",
        element: <TimeSheet />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
]);

export default router;
